import React, { useEffect, useState } from "react"
import { db } from "../../../utils/firebase"
import moment from "moment"

import WindowCard from "../../../components/ui/window-card/window-card"

// Activity types that count as an outbound touch
const OUTBOUND_TOUCH_TYPES = ["EMAIL_SENT", "CALL_MADE", "VOICEMAIL_LEFT"]

/**
 * Right-rail card showing how this enquiry has been progressing
 */
export default function LifecycleCard({ enquiryID, created, followUpDate }) {
	const [touches, setTouches] = useState({ count: 0, lastSeconds: null })

	useEffect(() => {
		if (!enquiryID) return
		const unsubscribe = db
			.collection(`enquiries/${enquiryID}/activity`)
			.onSnapshot((snap) => {
				const outbound = snap.docs
					.map((d) => d.data())
					.filter((a) => OUTBOUND_TOUCH_TYPES.includes(a.type))
				const lastSeconds = outbound
					.map((a) => a.created?.seconds || 0)
					.sort((a, b) => b - a)[0]
				setTouches({ count: outbound.length, lastSeconds })
			})
		return () => unsubscribe()
	}, [enquiryID])

	const createdMoment = created?.seconds ? moment(created.seconds, "X") : null
	const ageDays = createdMoment ? moment().diff(createdMoment, "days") : null

	const followUpMoment = followUpDate ? moment(followUpDate) : null
	const daysToFollowUp = followUpMoment ? followUpMoment.startOf("day").diff(moment().startOf("day"), "days") : null

	const lastTouchLabel = touches.lastSeconds ? moment(touches.lastSeconds, "X").fromNow() : null

	return (
		<WindowCard title="Lifecycle">
			<div className="enquiry-card-body">
				<div className="enquiry-card-row">
					<span className="enquiry-card-label">Created</span>
					<span className="enquiry-card-value">
						{createdMoment ? createdMoment.format("MMM D, YYYY") : <small className="no-value">—</small>}
					</span>
				</div>

				<div className="enquiry-card-row">
					<span className="enquiry-card-label">Age</span>
					<span className="enquiry-card-value">
						{ageDays !== null ? `${ageDays} ${ageDays === 1 ? "day" : "days"}` : <small className="no-value">—</small>}
					</span>
				</div>

				<div className="enquiry-card-row">
					<span className="enquiry-card-label">Last outbound touch</span>
					<span className="enquiry-card-value">
						{lastTouchLabel || <small className="no-value">—</small>}
					</span>
				</div>

				<div className="enquiry-card-row">
					<span className="enquiry-card-label">Outbound touches</span>
					<span className="enquiry-card-value">{touches.count}</span>
				</div>

				<div className="enquiry-card-row">
					<span className="enquiry-card-label">Follow up</span>
					<span className="enquiry-card-value">
						{followUpMoment ? (
							<>
								{followUpMoment.format("MMM D, YYYY")}{" "}
								<small className="no-value">
									({daysToFollowUp === 0 ? "today" : daysToFollowUp > 0 ? `in ${daysToFollowUp}d` : `${Math.abs(daysToFollowUp)}d overdue`})
								</small>
							</>
						) : (
							<small className="no-value">Not scheduled</small>
						)}
					</span>
				</div>
			</div>
		</WindowCard>
	)
}
